
const publicFun = function(Vue, options) {
	Vue.prototype.refreshPage = function() {
	    window.location.reload();
	},
	Vue.prototype.toPage = function(to_url) {
		this.$router.push({
			name: to_url
		});
	},
	Vue.prototype.toTop = function() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth' // 平滑滚动
		});
	},
	Vue.prototype.openPage = function(url) {
		var hostName = window.location.protocol + '//' + window.location.host;
		location.href = url
	},
	Vue.prototype.goBack = function() {
		history.back();
	},
	Vue.prototype.webIsMobile = function() {
		if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
			return true;
		} else {
			//电脑端
			return false;
		}
	},
	Vue.prototype.validateEmail = function(email) {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	},
	Vue.prototype.paginate = function(total_size) {
		var page = []
		for (var i = 0; i < total_size; i++) {
			page.push(i + 1)
		}

		return page;
	},
	Vue.prototype.calculatePaginate = function(currentPage, prePage, totalPage) {
		var startPage = 0
		var endPage = 9
		if (currentPage > prePage) { //前进
			if (currentPage > 5) {
				if ((totalPage - currentPage) < 4) {
					startPage = totalPage - 9
					endPage = totalPage
				} else {
					startPage = currentPage - 5
					endPage = currentPage + 4
				}
			}
		} else {
			if (currentPage > 5) {
				if ((totalPage - currentPage) < 4) {
					startPage = totalPage - 9
					endPage = totalPage
				} else {
					startPage = currentPage - 5
					endPage = currentPage + 4
				}
			} else {
				startPage = 0
				endPage = 9
			}
		}

		return {
			"startPage": startPage,
			"endPage": endPage
		};
	},
	Vue.prototype.isInArray = function(array, elementToFind) {
		let isInArray = array.indexOf(elementToFind) !== -1;
		return isInArray;
	},
	Vue.prototype.scrollToTop = function() {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth' // 平滑滚动
		});
	},
	Vue.prototype.multiplicationFormat = function(num1, num2) {
		return (num1 * num2).toFixed(2);
	},
	Vue.prototype.addHighPrecision = function(a, b) {
		const precision = Math.max(this.getPrecision(a), this.getPrecision(b));
		const multiplier = Math.pow(10, precision);
		return (Math.round(a * multiplier) + Math.round(b * multiplier)) / multiplier;
	},
	Vue.prototype.getPrecision = function(num) {
		const str = String(num);
		const decimalIndex = str.indexOf('.');
		return decimalIndex === -1 ? 0 : str.length - decimalIndex - 1;
	},
	Vue.prototype.multiply = function(a, b) {
		let num1 = a.toString().split('.')[1] || '';
		let num2 = b.toString().split('.')[1] || '';
		let maxDigits = Math.max(num1.length, num2.length);
		let result = (a * b) / Math.pow(1, maxDigits);
		return Number(result.toFixed(maxDigits));
	},
	Vue.prototype.doNothing = function() {
		return false;
	},
	Vue.prototype.NumberCheck = function(num) {
		var str = num;
		var len1 = str.substr(0, 1);
		var len2 = str.substr(1, 1);
		//如果第一位是0，第二位不是点，就用数字把点替换掉
		if (str.length > 1 && len1 == 0 && len2 != ".") {
			str = str.substr(1, 1);
		}
		//第一位不能是.
		if (len1 == ".") {
			str = "";
		}
		//限制只能输入一个小数点
		if (str.indexOf(".") != -1) {
			var str_ = str.substr(str.indexOf(".") + 1);
			if (str_.indexOf(".") != -1) {
				str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
			}
		}
		//正则替换，保留数字和小数点
		str = str.replace(/[^\d^\.]+/g, '')
		//如果需要保留小数点后两位，则用下面公式
		//str = str.replace(/\.\d\d$/, '')
		str = str.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数

		return str;
	},
	Vue.prototype.generateYear = function(start,end) {
		var yearArr = []
		for (let year = start; year <= end; year++) {
			let lastTwoDigitsOfYear = year % 100;
		    yearArr.push(
				{key:lastTwoDigitsOfYear,title:year}
			)
		}
		return yearArr;
	}
	
}
export default publicFun; //
